import { ReferenceField, FunctionField, useRecordContext } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { EventType, Event } from '../../types';
import BedMeshHeightMap from './BedMeshHeightMap';

const NeedBedCalibrationContent = ({
  eventType,
  record,
}: {
  record?: Event;
  eventType: EventType;
}) => {
  if (!record?.rawContent) return null;
  if (eventType.name !== 'need-bed-calibration') return null;

  try {
    const rawData = JSON.parse(record.rawContent);
    const calibrations = rawData?.fields?.calibrations;

    if (!calibrations || !Array.isArray(calibrations) || calibrations.length === 0) return null;

    return (
      <Box
        sx={{
          p: 2,
          gridColumn: { xs: '1', sm: '1 / -1' },
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Bed Calibrations ({calibrations.length})
        </Typography>
        {calibrations.map((calibration, index) => (
          <Box
            key={index}
            sx={{
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              backgroundColor: (theme) =>
                theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
            }}
          >
            <BedMeshHeightMap calibration={calibration} index={index} />
          </Box>
        ))}
      </Box>
    );
  } catch {
    // Error parsing rawContent, silently ignore
    return null;
  }
};

export const NeedBedCalibration = () => {
  const record = useRecordContext<Event>();
  return (
    <ReferenceField source="eventTypeId" reference="event-types" link={false}>
      <FunctionField
        render={(eventType: EventType) => (
          <NeedBedCalibrationContent record={record} eventType={eventType} />
        )}
      />
    </ReferenceField>
  );
};
